export default [{
  path: '/',
  question: "Let's get started. What are you trying to do?",
  model: {
    form_name: {
      type: 'hidden',
      value: 'Basic'
    },
    loan_type: {
      type: 'button_list',
      options: ['Purchase', 'Refinance']
    }
  }
},
{
  path: '/property-location-p',
  conditions: [
    ['loan_type', '=', 'Purchase']
  ],
  question: 'Where are you looking to buy a home?',
  showNextButton: true,
  model: {
    property_location: {
      placeholder: 'City, State',
      type: 'text'
    }
  }
},
{
  path: '/property-location-r',
  conditions: [
    ['loan_type', '=', 'Refinance']
  ],
  question: 'Where is your home located?',
  showNextButton: true,
  model: {
    property_location: {
      type: 'text'
    }
  }
},
{
  path: '/first-time-homebuyer',
  conditions: [
    ['loan_type', '=', 'Purchase']
  ],
  question: 'Are you a first-time home buyer?',
  model: {
    first_time_home_buyer: {
      type: 'yes_no'
    }
  }
},
{
  path: '/timing',
  conditions: [
    ['loan_type', '=', 'Purchase']
  ],
  question: 'Where are you at in the home-buying process?',
  model: {
    timing: {
      type: 'button_list',
      options: [
        'Just looking at listings',
        'Touring Homes',
        'Making or made an offer',
        'Under contract'
      ]
    }
  }
},

{
  path: '/buy-and-sell',
  conditions: [
    ['loan_type', '=', 'Purchase'],
    ['first_time_home_buyer', '=', 'no']
  ],
  question: 'Are you planning to sell a home in addition to buying one? Our loan officers can help you understand your options.',
  model: {
    buy_and_sell: {
      type: 'yes_no'
    }
  }
},

{
  path: '/real-estate-agent',
  conditions: [
    ['loan_type', '=', 'Purchase']
  ],
  question: 'Are you working with a real estate agent?',
  help: "If you do, we'll connect with your agent to make sure we keep them updated about your loan",
  model: {
    has_real_estate_agent: {
      type: 'yes_no'
    }
  }
},

{
  path: '/property-type-p',
  conditions: [
    ['loan_type', '=', 'Purchase']
  ],
  question: 'What kind of home are you looking for?',
  help: 'It can make a difference in the type of loan you can get.',
  model: {
    property_type: {
      type: 'button_list',
      options: [
        { label: 'Single Family Home', icon: '<i class="fal fa-house"></i>' },
        { label: 'Townhome', icon: '<i class="fal fa-hotel"></i>' },
        { label: 'Condominium', icon: '<i class="fal fa-building"></i>' },
        { label: 'Mobile or manufactured', icon: '<i class="fal fa-caravan-alt"></i>' }
      ]
    }
  }
},

{
  path: '/property-type-r',
  conditions: [
    ['loan_type', '=', 'Refinance']
  ],
  question: 'What kind of home do you currently own?',
  help: 'It can make a difference in the interest rate you get.',
  model: {
    property_type: {
      type: 'button_list',
      options: [
        'Single Family Home',
        'Townhome',
        'Condominium',
        'Mobile or manufactured'
      ]
    }
  }
},

{
  path: '/property-use-p',
  conditions: [
    ['loan_type', '=', 'Purchase']
  ],
  question: 'How do you plan to use your new home?',
  help: "Your loan options may vary depending on the home's use.",
  model: {
    property_use: {
      type: 'button_list',
      options: [
        {
          label: 'Primary Residence',
          icon: '<i class="fas fa-home-heart"></i>'
        },
        {
          label: 'Secondary or vacation home',
          icon: '<i class="fal fa-tree-palm"></i>'
        },
        {
          label: 'Investment property',
          icon: '<i class="fal fa-sack-dollar"></i>'
        }
      ]
    }
  }
},

{
  path: '/property-use-r',
  conditions: [
    ['loan_type', '=', 'Refinance']
  ],
  question: 'How are you using this home?',
  help: "It'll affect your home loan options.",
  model: {
    property_use: {
      type: 'button_list',
      options: [
        'Primary Residence',
        'Secondary or vacation home',
        'Investment property'
      ]
    }
  }
},

{
  path: '/military-service',
  conditions: [
    ['loan_type', '=', 'Purchase']
  ],
  question: 'Are you (or your spouse) a veteran or active duty military?',
  help: 'If so, you may qualify for a VA loan.',
  model: {
    is_veteran: {
      type: 'yes_no'
    }
  }
},

{
  path: '/military-service-r',
  conditions: [
    ['loan_type', '=', 'Refinance']
  ],
  question: 'Are you (or your spouse) a veteran or active duty military?',
  help: 'If so, you may qualify for a VA Interest Rate Reduction Refinance Loan (IRRRL).',
  model: {
    is_veteran: {
      type: 'yes_no'
    }
  }
},

{
  path: '/Purchase-price',
  conditions: [
    ['loan_type', '=', 'Purchase']
  ],
  question: "What's your target Purchase price?",
  help: "It's ok to estimate.",
  showNextButton: true,
  model: {
    Purchase_price: {
      type: 'dollar'
    }
  }
},

{
  path: '/property-value',
  conditions: [
    ['loan_type', '=', 'Refinance']
  ],
  question: "What's the value of your home?",
  help: "It's ok to estimate.",
  showNextButton: true,
  model: {
    property_value: {
      type: 'dollar',
      default: '$400,000'
    }
  }
},

{
  path: '/current-loan-amount',
  conditions: [
    ['loan_type', '=', 'Refinance']
  ],
  question: "What's your balance of your current loan?",
  help: "It's ok to estimate.",
  showNextButton: true,
  model: {
    current_loan_amount: {
      type: 'dollar',
      default: '$300,000'
    }
  }
},

{
  path: '/second-mortgage',
  conditions: [
    ['loan_type', '=', 'Refinance']
  ],
  question: 'Do you have a second mortgage or a home equity line of credit on this property?',
  model: {
    second_mortgage_or_home_equity_line_of_credit: {
      type: 'yes_no'
    }
  }
},

{
  path: '/second-mortgage-amount',
  conditions: [
    ['loan_type', '=', 'Refinance'],
    ['second_mortgage_or_home_equity_line_of_credit', '=', 'yes']
  ],
  question: 'What\'s your balance of second mortgage or home equity line of credit?',
  help: "It's ok to estimate.",
  showNextButton: true,
  model: {
    second_mortgage_amount: {
      type: 'dollar',
      default: '$80,000'
    }
  }
},

{
  path: '/additional-cash',
  conditions: [
    ['loan_type', '=', 'Refinance']
  ],
  question: 'Do you want to borrow additional cash when you Refinance?',
  model: {
    additional_cash: {
      type: 'yes_no'
    }
  }
},

{
  path: '/down-payment',
  conditions: [
    ['loan_type', '=', 'Purchase']
  ],
  question: 'How much do you have for a down payment?',
  help: "Military service may qualify you for a VA loan, which doesn't usually require a down payment. However, you can choose to make a down payment to lower your monthly mortgage payment.",
  showNextButton: true,
  model: {
    down_payment: {
      type: 'dollar',
      default: '$20,000'
    }
  }
},

{
  path: '/annual-income',
  question: 'What\'s your annual income before taxes?',
  help: 'The amount you may qualify for depends partially on your income.',
  showNextButton: true,
  model: {
    annual_income: {
      type: 'dollar',
      default: '$75,000'
    }
  }
},

{
  path: '/credit-score',
  question: 'Do you know your credit score?',
  help: 'It\'s ok to estimate.',
  model: {
    credit_score: {
      type: 'button_list',
      options: [
        'Excellent: 720 and above',
        'Good: 660-719',
        'Average: 620-659',
        'Poor: 580-619',
        'Bad: 579 or below',
        'I don\'t know'
      ]
    }
  }
},

{
  path: '/self-employed',
  question: 'Are you self-employed?',
  model: {
    self_employed: {
      type: 'yes_no'
    }
  }
},

{
  path: '/disclosures',
  question: 'Have you had a bankruptcy, foreclosure, or short sale in the past 2 years?',
  help: 'Experiencing one of these events doesn\'t mean that you can\'t get a loan, but it can affect your eligibility for certain loan programs.',
  model: {
    bankruptcy_foreclosure_short_sale: {
      type: 'yes_no'
    }
  }
},

{
  path: '/name',
  question: 'Almost there! What\'s your name?',
  showNextButton: true,
  model: {
    name: {
      type: 'name'
    }
  }
},

{
  path: '/email',
  question: 'Nice to meet you #first_name#. What\'s your email address?',
  showNextButton: true,
  model: {
    email: {
      type: 'email',
      required: false
    }
  }
},

{
  path: '/phone',
  question: 'What\'s the best number to reach you?',
  model: {
    phone: {
      type: 'phone'
    },
    submit: {
      type: 'submit',
      label: 'GET MY QUOTE'
    }
  }
},

{
  path: '/end',
  question: 'Thank you!  We\'ve recieved your information.  We\'ll be in touch shortly.',
  model: {}
}
]
